module.exports = __webpack_public_path__ + "static/media/certification.d98ce538.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/certification.png
// module id = 317
// module chunks = 0